// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>3</span>&nbsp;&nbsp;Blow the trumpet at the new moon,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;as at the full moon, upon our solemn feast day.<br> </p> </div></div>";
// Exports
module.exports = code;